import { AxiosResponse } from 'axios';
import { axiosInstance } from '../../helpers/api_helper';

export interface AboutCardOne {
    id: number;
    pageID: string;
    pageName: string;
    pageContent: string;
    createdBy: string;
    updatedBy: string;
    updated: string;
    createdAt: string;
    pageStatus: number;
}

async function getAboutCardOne(): Promise<AboutCardOne | undefined> {
    const apiUrl = '/FrontPage/Page/f938ce6f-b82b-43f1-85df-411e6e2312e6';

    try {
        const response: AxiosResponse<{ data: AboutCardOne }> = await axiosInstance.get(apiUrl);

        // Log the entire response data
        console.log('About Us Page Response Data:', response.data);

        // Extract and return the about us page information
        return response.data.data;
    } catch (error: any) {
        console.error('Error fetching About Us page:', error.message);
        // Handle errors here
        throw error;
    }
}

export { getAboutCardOne };
